
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cruises/articles",
      function () {
        return require("private-next-pages/cruises/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cruises/articles"])
      });
    }
  